import { iseeInstance } from '../axiosService'
import { getJWT } from '../../utils/functions'

/**
 * Stream one support-agent turn. `input` is any of { message, approvals, clientResults }.
 * Calls onEvent for each server-sent event: start, token, tool_start, tool_end,
 * action_required, error, done.
 */
const streamChat = async ({ portal, conversationId, ...input }, { onEvent, signal }) => {
  const token = await getJWT()
  const response = await fetch(`${iseeInstance.defaults.baseURL}/support/chat`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    },
    body: JSON.stringify({ portal, conversationId, ...input }),
    signal
  })

  if (!response.ok) {
    const body = await response.json().catch(() => ({}))
    const error = new Error(body.error || `Support request failed: ${response.status}`)
    error.status = response.status
    throw error
  }

  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''
  while (true) {
    const { done, value } = await reader.read()
    if (done) break
    buffer += decoder.decode(value, { stream: true })
    const lines = buffer.split('\n')
    buffer = lines.pop() // keep incomplete line in buffer
    for (const line of lines) {
      if (!line.startsWith('data: ')) continue
      let event
      try {
        event = JSON.parse(line.slice(6))
      } catch { continue /* ignore malformed lines */ }
      onEvent(event)
    }
  }
}

const SupportService = {
  streamChat,
  getLatestConversation: (portal) => iseeInstance.get('/support/conversations/latest', { params: { portal } }),
  closeConversation: (conversationId, portal) => iseeInstance.post(`/support/conversations/${conversationId}/close`, { portal })
}

export default SupportService
